import React from 'react';
import clsx from 'clsx';
import { translate } from '../../../Services/translation';

const AddressListItemMobile = ({ address }: { address: any }) => {
  return (
    <div
      className={clsx(
        'flex',
        'justify-between',
        'items-center',
        'p-4',
        'border',
        'border-solid',
        'border-gray-300',
        'rounded',
        'mb-4'
      )}
    >
      <div className={clsx('flex', 'flex-col')}>
        <p className={clsx('text-base', 'capitalize', 'font-bold')}>
          {address.address}
        </p>
        <p className={clsx('text-md', 'capitalize')}>
          {address.zipCode} {address.city}
        </p>
        <p className={clsx('text-md', 'capitalize')}>{address.country}</p>
        {address.addressType && (
          <p className={clsx('text-md', 'capitalize')}>
            {translate(
              'mypage.address.type.' + address.addressType.toLowerCase()
            )}
          </p>
        )}
      </div>
    </div>
  );
};
export default AddressListItemMobile;
